import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router'
import { Breadcrumbs, ContainerHeader, variantActionsProps } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ClickToTextRoutes } from 'pages/clickToText'
import { getClickToTextActions } from 'pages/clickToText/pages/all/ui/ClickToTextTable/getClickToTextActions'
import { useClickToTextDetailsContext } from 'pages/clickToText/pages/viewClickToText/context'

export const ClickToTextDetailsHeader = observer(() => {
  const { clickToText, pageLayoutStore } = useClickToTextDetailsContext()
  const { titleIconProps, headerMenuIconAction, headerMenuTooltipIconProps } = pageLayoutStore
  const navigate = useNavigate()
  const entities = useEntitiesContext()

  if (!clickToText) return null

  const { name } = clickToText

  const onSuccessDelete = () => {
    navigate(`${ClickToTextRoutes.root}`)
  }

  return (
    <div>
      <Breadcrumbs customPath={`/${ClickToTextRoutes.root}`} getLabel={() => 'Click to text'} />
      <ContainerHeader
        paddingTop={16}
        paddingBottom={12}
        title={name}
        titleVariant={'heading-md'}
        titleIconProps={titleIconProps}
        titleIconAction={headerMenuIconAction}
        actionIconTooltipProps={headerMenuTooltipIconProps}
        actionsProps={{
          ...variantActionsProps['headerMedium'],
          showItems: 2,
          actions: getClickToTextActions({ clickToText, onSuccessDelete, entities }),
        }}
        paddingLeft={20}
        paddingRight={20}
        ellipsis
      />
    </div>
  )
})
